import { construirFecha } from "./ConstruirFecha";

const construirRetenciones = (
  retSuss,
  retIva,
  retGanancias,
  retDrei,
  retencionesIIBB,
) => {
  const tieneRetenciones =
    retSuss || retIva || retGanancias || retDrei || retencionesIIBB?.length > 0;

  const retenciones = tieneRetenciones
    ? {
        suss: parseFloat(retSuss) || null,
        iva: parseFloat(retIva) || null,
        ganancias: parseFloat(retGanancias) || null,
        drei: parseFloat(retDrei) || null,
        iibb: retencionesIIBB
          .filter((r) => r.provincia_id && r.importe)
          .map((r) => ({
            provincia_id: r.provincia_id,
            importe: parseFloat(r.importe),
          })),
      }
    : null;

  return retenciones;
};

const construirRecibo = (
  clienteCuit,
  numCliente,
  FechaDePago,
  numRecibo,
  usaReciboElectronico,
  efectivo,
  redondeo,
  idCliente,
  idTipoNegocio,
) => {
  return {
    cuit: clienteCuit,
    num_cliente: numCliente,
    fecha_de_pago: construirFecha(
      FechaDePago.dia,
      FechaDePago.mes,
      FechaDePago.ano,
    ),
    pto_vta: numRecibo.ptoVta,
    numero_recibo: numRecibo.numero,
    es_recibo_electronico: usaReciboElectronico ? 1 : 0,
    efectivo: parseFloat(efectivo) || null,
    user: localStorage.getItem("user"),
    redondeo: parseFloat(redondeo) || null,
    id_cliente: idCliente,
    id_tipo_negocio: idTipoNegocio,
  };
};

const construirTarjetas = (tarjetas) => {
  return tarjetas
    .filter((t) => t.tipo_id && t.importe)
    .map((t) => ({
      tipo: t.tipo_id,
      banco_id: t.banco_id,
      marca_id: t.marca_id,
      lote: t.lote || null,
      cupon: t.cupon || null,
      ultimos4: t.ultimos4,
      importe: parseFloat(t.importe),
    }));
};

const construirInstrumentos = (instrumentos) => {
  return instrumentos
    .filter((inst) => inst.tipo_id && inst.importe)
    .map((inst) => {
      const requiereCuitFirma =
        inst.tipo_id === 4 || inst.tipo_id === 3 || inst.tipo_id === 6; // Cheque/Echeq/Transferencia

      const requiereFechaDePago =
        inst.tipo_id === 3 || inst.tipo_id === 6; // Cheque/Echeq

      const esQr = inst.tipo_id === 5; // Tarea #871: crédito QR de un pedido anulado

      return {
        tipo: inst.tipo_id,
        banco_id: inst.banco_id,
        nro_comprobante: inst.nro_comprobante || null,
        fecha: construirFecha(inst.dia, inst.mes, `20${inst.ano}`), // Asume 20XX
        ...(requiereFechaDePago
          ? { fecha_de_pago: inst.fecha_de_pago || null }
          : {}),
        importe: parseFloat(inst.importe),
        cuit_firma: requiereCuitFirma ? inst.cuit_firma : null,
        ...(esQr ? { pago_combinado_id: inst.pago_combinado_id } : {}),
      };
    });
};
export const construirPayload = (formData) => {
  const {
    clienteCuit,
    numCliente,
    FechaDePago,
    numRecibo,
    usaReciboElectronico,
    efectivo,
    redondeo,
    idCliente,
    idTipoNegocio,
    retSuss,
    retIva,
    retGanancias,
    retDrei,
    retencionesIIBB,
    instrumentos,
    tarjetas,
    totalCobrado,
    imputaciones,
  } = formData;

  const recibo = construirRecibo(
    clienteCuit,
    numCliente,
    FechaDePago,
    numRecibo,
    usaReciboElectronico,
    efectivo,
    redondeo,
    idCliente,
    idTipoNegocio,
  );

  const retenciones = construirRetenciones(
    retSuss,
    retIva,
    retGanancias,
    retDrei,
    retencionesIIBB,
  );

  const instrumentosPayload = construirInstrumentos(instrumentos);

  const tarjetasPayload = construirTarjetas(tarjetas);

  return {
    recibo,
    retenciones,
    instrumentos: instrumentosPayload,
    tarjetas: tarjetasPayload,
    imputaciones: imputaciones || [],
    total: parseFloat(totalCobrado.toFixed(2)),
  };
};
